import React from 'react';
import { Box, Text } from '@chakra-ui/react';

export const NotFoundPage: React.FC = () => {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      height="100vh"
      bg="gray.100"
    >
      <Text fontSize="2xl" color="red.500">
        Page not found
      </Text>
    </Box>
  );
};
